<section class="settings-page">
  <header class="admin-header">
    <div>
      <h1>Settings</h1>
      <p>Basic admin preferences and website defaults.</p>
    </div>
  </header>

  <div class="status success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="status error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <form class="settings-card" [formGroup]="settingsForm">
    <label>Site name <input type="text" formControlName="siteName" /></label>
    <label>Admin email display <input type="email" formControlName="adminEmailDisplay" /></label>
    <label>Default product image URL <input type="text" formControlName="defaultProductImageUrl" /></label>

    <label class="toggle-field">
      <input type="checkbox" formControlName="maintenanceMode" />
      <span>
        Maintenance mode
        <small>Placeholder only. Public website behavior is unchanged.</small>
      </span>
    </label>

    <footer>
      <button type="button" class="primary-button" (click)="saveSettings()" [disabled]="isSaving">
        {{ isSaving ? 'Saving...' : 'Save Settings' }}
      </button>
    </footer>
  </form>
</section>
